import $ from 'jquery';

const bodyClasses = (function () {
    const classes = $('body').attr('class');

    if (typeof classes === 'undefined') {
        return '';
    }

    return classes.split(' ');
}());

export default {
    is(className) {
        return bodyClasses.indexOf(className) !== -1;
    },
    isOneOf(classesArray) {
        let found = false;

        classesArray.forEach( className => {
            if (bodyClasses.indexOf(className) !== -1) {
                found = true;
                return;
            }
        });

        return found;
    }
};




// WEBPACK FOOTER //
// ./src/js/utils/pageNow.js